import { Typography } from '@mui/material'

import { Copy, CopyContainer } from '../common/copy'

interface LeadCopyProps {
  name?: string
  title?: string
  subTitle?: string
}

const LeadCopy = (props: LeadCopyProps) => {
  const { name, title, subTitle } = props

  return (
    <>
      {(name || title || subTitle) && (
        // <CopyContainer padding="large" noRightMargin={true}>
        <CopyContainer
          padding={{
            top: 'small',
            left: 'large',
            right: 'xsmall',
            bottom: 'large',
          }}
        >
          {name && (
            <CopyContainer padding={{ bottom: 'small' }}>
              <Copy>
                <Typography variant="h6" align="right">
                  {name}
                </Typography>
              </Copy>
            </CopyContainer>
          )}
          {(title || subTitle) && (
            <CopyContainer padding={{ left: 'small' }}>
              <Copy stackSpacing="small">
                {title && <Typography variant="h2">{title}</Typography>}
                {subTitle && <Typography variant="h4">{subTitle}</Typography>}
              </Copy>
            </CopyContainer>
          )}
        </CopyContainer>
      )}
    </>
  )
}

export default LeadCopy
